<template>
    <div id="bot-index">
        <bot-fund-types :pf="pf"></bot-fund-types>
    </div>
</template>


<script>




export default{
    props:['pf'],
    mounted() {
    console.log(this.pf)
        //this.permission = this.$acl['Bot/details'];
    },
    
    data(){
        return{
            permission: '',
        }
    },
}


</script>



